module.exports = __webpack_public_path__ + "img/image6.c30c41e0.svg";